const filterVersions = (versions, language) => versions.filter(version => version.language.id === language);

export default filterVersions;
